import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export function TableListItem(props) {
    const { columnDef, item, children, testId } = props;
    if (!columnDef) return null;
    const { width: columnWidth, hAlign } = columnDef;
    const width = typeof columnWidth === 'number' ? columnWidth : null;
    const minWidth = typeof columnWidth === 'object' ? columnWidth[0] : columnWidth;
    const maxWidth = typeof columnWidth === 'object' ? columnWidth[1] : columnWidth;
    const fluid = minWidth ? 1 : null;
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": item.testId || testId,
        className: item.className,
        style: {
            textAlign: hAlign || 'left',
            width,
            minWidth,
            maxWidth,
            flex: fluid,
            alignSelf: 'center'
        },
        children: children || item.value
    });
}
